export const FinishingPermissions = {
  Manager: [
    {
      path: "/finishing/packing-lists",
      label: "Packings",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/finishing/left-overs",
      label: "Left Overs",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/finishing/receives",
      label: "Receives",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/finishing/returns",
      label: "Returns",
      icon: "fas fa-chevron-right me-1",
    },
  ],
  "Assistant Manager": [
    {
      path: "/finishing/packing-lists",
      label: "Packings",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/finishing/left-overs",
      label: "Left Overs",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/finishing/receives",
      label: "Receives",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/finishing/returns",
      label: "Returns",
      icon: "fas fa-chevron-right me-1",
    },
  ],
  Executive: [
    {
      path: "/finishing/packing-lists",
      label: "Packings",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/finishing/left-overs",
      label: "Left Overs",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/finishing/receives",
      label: "Receives",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/finishing/returns",
      label: "Returns",
      icon: "fas fa-chevron-right me-1",
    },
  ],
  "Jr. Executive": [
    {
      path: "/finishing/packing-lists",
      label: "Packings",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/finishing/left-overs",
      label: "Left Overs",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/finishing/receives",
      label: "Receives",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/finishing/returns",
      label: "Returns",
      icon: "fas fa-chevron-right me-1",
    },
  ],
  "Sr. Executive": [
    {
      path: "/finishing/packing-lists",
      label: "Packings",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/finishing/left-overs",
      label: "Left Overs",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/finishing/receives",
      label: "Receives",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/finishing/returns",
      label: "Returns",
      icon: "fas fa-chevron-right me-1",
    },
  ],

  "Finishing Incharge": [
    {
      path: "/finishing/packing-lists",
      label: "Packings",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/finishing/left-overs",
      label: "Left Overs",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/finishing/receives",
      label: "Receives",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/finishing/returns",
      label: "Returns",
      icon: "fas fa-chevron-right me-1",
    },
  ],
};
